import {
    Dialog,
    Tabs,
    TabPane,
    Tree,
    Alert,
    Loading,
    MessageBox,
    Message,
    Notification,
    Button,
    Table,
    TableColumn,
    Row,
    Col,
    Tooltip,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Input,
    Popover,
    Tag,
    DatePicker,
    Transfer,
    Radio,
    RadioGroup,
    Pagination,
    Select,
    Option
} from 'element-ui/lib/element-ui.common.js'

const components = [  //需要用到的组件;
    Dialog,
    Tabs,
    TabPane,
    Tree,
    Alert,
    Button,
    Table,
    TableColumn,
    Row,
    Col,
    Tooltip,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Input,
    Popover,
    Tag,
    DatePicker,
    Transfer,
    Radio,
    RadioGroup,
    Pagination,
    Select,
    Option
];

function _Notification(options) {
    options.offset = 20;
    options.duration = options.duration ? options.duration : 2000;
    let vm = Notification(options);
    let top = vm.$data.top;
    vm.$data.top = false;
    vm.$el.style.bottom = top + 'px';
}


['success', 'warning', 'info', 'error', 'close'].forEach(type => {
    _Notification[type] = options => {
        if (typeof options === 'string' || isVNode(options)) {
            options = {
                message: options
            };
        }
        options.type = type;
        return _Notification(options);
    };
});
_Notification.close = Notification.close;


export default{
    install(Vue, opts = {}){
        //locale.use(opts.locale);
        //locale.i18n(opts.i18n);

        components.map(component => {
            Vue.component(component.name, component);
        });

        // 全局引入插件;
        Vue.use(Loading.directive);

        Vue.prototype.$loading = Loading.service;
        Vue.prototype.$msgbox = MessageBox;
        Vue.prototype.$alert = MessageBox.alert;
        Vue.prototype.$confirm = MessageBox.confirm;
        Vue.prototype.$prompt = MessageBox.prompt;
        Vue.prototype.$toast = _Notification;
        Vue.prototype.$message = Message;
    }
};



// WEBPACK FOOTER //
// ./src/plugins/element-plugnins/index.js